<template>
    <div class="elle-layout">
        <CommonHeader />
        <main id="elle-main" class="elle-main">
            <WidgetZipCode />
            <div id="lenis-wrapper" class="lenis-wrapper">
                <main id="lenis-content" class="lenis-content is-global-loading">
                    <div id="lenis-slot" class="lenis-slot">
                        <slot />
                        <CommonFooter />
                    </div>
                </main>
            </div>
        </main>
    </div>
</template>

<script setup lang="ts"></script>
